var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-164 42.3 512 512",
    style: {
      enableBackground: "new -164 42.3 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#843B90;}\n\t.st1{fill:#7ED5C5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -110.7,
    y: 127.6,
    className: "st0",
    width: 106.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -110.7,
    y: 170.3,
    className: "st0",
    width: 170.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -110.7,
    y: 212.9,
    className: "st0",
    width: 106.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -110.7,
    y: 255.6,
    className: "st0",
    width: 170.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -110.7,
    y: 298.3,
    className: "st0",
    width: 106.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -110.7,
    y: 340.9,
    className: "st0",
    width: 170.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -110.7,
    y: 383.6,
    className: "st0",
    width: 106.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -110.7,
    y: 426.3,
    className: "st0",
    width: 170.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220,287.6c11.8,0,21.3,9.6,21.3,21.3h21.3c0-19.9-13.6-36.6-32-41.3v-12h-21.3v12 c-18.4,4.7-32,21.4-32,41.3c0,23.6,19.1,42.7,42.7,42.7c11.8,0,21.3,9.6,21.3,21.3s-9.6,21.3-21.3,21.3s-21.3-9.6-21.3-21.3 h-21.3c0,19.9,13.6,36.6,32,41.3v12h21.3v-12c18.4-4.7,32-21.4,32-41.3c0-23.6-19.1-42.7-42.7-42.7c-11.8,0-21.3-9.6-21.3-21.3 C198.7,297.2,208.2,287.6,220,287.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220,212.9c-44.5,0-83.7,22.7-106.7,57.2v-57.2H92v256h21.3v-57.2c22.9,34.5,62.1,57.2,106.7,57.2 c70.7-0.1,127.9-57.3,128-128C348,270.3,290.7,212.9,220,212.9z M220,447.6c-58.9,0-106.7-47.8-106.7-106.7 S161.1,234.3,220,234.3c58.9,0.1,106.6,47.8,106.7,106.7C326.7,399.9,278.9,447.6,220,447.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.7,500.9h-53.3v-21.3H156v21.3H-89.3c-5.9,0-10.7,4.8-10.7,10.7c0,11.8-9.6,21.3-21.3,21.3 s-21.3-9.6-21.3-21.3V68.7l38.7,15.5c2.5,1,5.4,1,7.9,0l49.4-19.8L2.7,84.2c2.5,1,5.4,1,7.9,0L60,64.4l49.4,19.8 c2.5,1,5.4,1,7.9,0L156,68.7v133.6h21.3V52.9c0-1.4-0.3-2.7-0.8-4c-2.2-5.5-8.4-8.1-13.9-5.9l-49.4,19.8L64,43 c-2.5-1-5.4-1-7.9,0L6.7,62.8L-42.7,43c-2.5-1-5.4-1-7.9,0L-100,62.8L-149.4,43c-1.3-0.5-2.6-0.8-4-0.8 c-5.9,0-10.7,4.8-10.7,10.7v458.7c0,23.6,19.1,42.7,42.7,42.7h320c23.6,0,42.7-19.1,42.7-42.7 C241.3,505.7,236.6,500.9,230.7,500.9z M198.7,532.9H-84.4c1.9-3.3,3.4-6.9,4.4-10.7h297.2C213.3,528.9,206.3,532.9,198.7,532.9z "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.9138d65040a15aaf7b073cc6b4dd22d6.svg";
export { ForwardRef as ReactComponent };